import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridProps, InputAdornment, SelectChangeEvent } from "@mui/material";
import { Search } from "@mui/icons-material";
import { InputSearching, InputDate, AppSelect } from "@/components/common";
import { AppConstant, LangConstant } from "@/const";
import { SearchDataFilter, useApplicationList, useRequestStatusList } from "@/hooks";

type IdSearchFilterProps = GridProps & {
  filter?: SearchDataFilter;
  onChangeFilter?: (filter: SearchDataFilter) => void;
};

const IdSearchFilter: FC<IdSearchFilterProps> = props => {
  const { filter, onChangeFilter } = props;
  const [filterTable, setFilterTable] = useState<SearchDataFilter>({
    ...filter,
  });
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const handleChangeFilter = (newFilter: SearchDataFilter) => {
    setFilterTable(newFilter);
    if (onChangeFilter) {
      onChangeFilter(newFilter);
    }
  };

  const handleChangeSearchId = (keyword: string) => {
    handleChangeFilter({ ...filterTable, identification: keyword });
  };

  const handleChangeStartDate = (value: Date | null) => {
    handleChangeFilter({ ...filterTable, start: value });
  };

  const handleChangeEndDate = (value: Date | null) => {
    handleChangeFilter({ ...filterTable, end: value });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <InputSearching
          placeholder={getLabel("OBJ_INPUT_SEARCH.searchById")}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
          defaultValue={filterTable?.identification}
          onSearch={handleChangeSearchId}
        />
      </Grid>

      <Grid item xs={3}>
        <InputDate
          label={getLabel("OBJ_INPUT_SEARCH.fromDate")}
          format={AppConstant.FM_SHORT_DATE}
          onChange={handleChangeStartDate}
          maxDate={filterTable.end || undefined}
        />
      </Grid>

      <Grid item xs={3}>
        <InputDate
          label={getLabel("OBJ_INPUT_SEARCH.toDate")}
          format={AppConstant.FM_SHORT_DATE}
          onChange={handleChangeEndDate}
          minDate={filterTable.start || undefined}
        />
      </Grid>
    </Grid>
  );
};

export default IdSearchFilter;
